// extracted by mini-css-extract-plugin
export default {"popover":"Popover_popover__AyPQ+","top":"Popover_top__vHatY","container":"Popover_container__wqR+1","animate":"Popover_animate__ycJ4O"};